import PropTypes from 'prop-types';
import React from 'react';

import { IconArrowRight } from '$partials/icons';

import {
    formatCalendarListingItemTime,
} from '$utilities/format';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const CalendarItem = ({
    __typename = null,
    calendarItemType,
    location = null,
    endDate = null,
    startDate = null,
    title = null,
    url = null
}) => {
    return (
        <div className='expand-interaction bg-white hover:bg-peach md:h-[124px]'>
            <div className='layout-container border-t border-t-charcoal py-30 md:h-full'>
                <div className='layout-grid-negative-gutter flex flex-wrap items-start sm:items-center md:h-full'>
                    <div className='hidden md:block md:w-1/12 layout-grid-col-padding' />

                    <h3 className='type-style-3 w-9/12 sm:w-9/12 md:w-4/12 layout-grid-col-padding line-clamp-2 mb-25 md:mb-0'>
                        {title}
                    </h3>

                    <p
                        className='type-style-4 w-6/12 sm:w-4/12 md:w-2/12 layout-grid-col-padding'
                        dangerouslySetInnerHTML={{ __html: formatCalendarListingItemTime(__typename, startDate, endDate) }} />

                    <div className='w-6/12 sm:w-6/12 md:w-4/12 flex flex-wrap flex-col sm:flex-row md:items-center'>
                        <p className='w-3/6 sm:w-4/6 md:w-6/12 layout-grid-col-padding type-style-4'>
                            {location}
                        </p>

                        <p className='w-3/6 sm:w-2/6 md:6/12 layout-grid-col-padding type-style-4'>
                            {calendarItemType}
                        </p>
                    </div>

                    <div className='w-1/12 sm:w-2/12 md:w-1/12 layout-grid-col-padding mt-30 sm:mt-0'>
                        <a
                            className='round-button sm:float-right expand-interaction__action'
                            href={url}>
                            <IconArrowRight />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

const propTypes = {
    __typename: PropTypes.string,
    calendarItemType: PropTypes.string,
    endDate: PropTypes.string,
    location: PropTypes.string,
    startDate: PropTypes.string,
    title: PropTypes.string,
    url: PropTypes.string,
};

CalendarItem.propTypes = propTypes;

export default CalendarItem;
